import { type FC, useMemo } from "react";
import { useShopfrontDispatch, useShopfrontSelector } from "../../../_Bootstrap/hooks";
import { unblockAudioTrack } from "../../../Actions/Audio/AudioActions";
import Button from "../../../Common/Buttons/Button";
import AudioManager from "../../../Utilities/Platform/Audio/AudioManager";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import AudioControl from "./AudioControl";

export const AudioMenu: FC = () => {
    const dispatch = useShopfrontDispatch();
    const tracks = useShopfrontSelector(state => state.audio.tracks);
    const systemTrackId = useShopfrontSelector(state => state.audio.systemTrack);

    const master = useMemo(() => {
        const audioManager = AudioManager.getInstance();

        if(!audioManager.isReady()) {
            return null;
        }

        return audioManager.getMasterTrack();
    }, []);

    const systemTrack = useMemo(() => {
        const audioManager = AudioManager.getInstance();

        if(!audioManager.isReady()) {
            return null;
        }

        if(systemTrackId === null) {
            return null;
        }

        return audioManager.getTrack(systemTrackId);
    }, [ systemTrackId ]);

    let content;

    if(master === null) {
        content = (
            <div className="audio-loading">
                <FontAwesomeLight
                    icon="spinner-third"
                    spin
                    className="mr-2"
                />
                Initialising Audio System
            </div>
        );
    } else {
        content = (
            <>
                <AudioControl
                    name="Master Volume"
                    track={master}
                />
                <hr />
                {systemTrack !== null && (
                    <AudioControl
                        name="Shopfront"
                        track={systemTrack}
                    />
                )}
                {tracks.map(track => {
                    if(track.track === null) {
                        const onUnblock = () => {
                            const newTrack = AudioManager.getInstance().createTrack(track.integration);

                            dispatch(unblockAudioTrack(track.id, newTrack.id));
                        };

                        return (
                            <div
                                key={track.id}
                                className="audio-control"
                            >
                                <div className="audio-name-wrapper">
                                    <div className="audio-name">{track.name}</div>
                                    <div className="audio-percentage"> - Blocked</div>
                                </div>
                                <div className="audio-actions">
                                    <Button
                                        onClick={onUnblock}
                                    >
                                        Unblock
                                    </Button>
                                </div>
                            </div>
                        );
                    }

                    return (
                        <AudioControl
                            key={track.id}
                            id={track.id}
                            name={track.name}
                            track={track.track}
                        />
                    );
                })}
            </>
        );
    }

    return (
        <div className="audio-menu">
            {content}
        </div>
    );
};
